import React, { useEffect } from 'react';
import { Navigate, Outlet, useNavigate } from 'react-router-dom';
import { isAuthenticated } from '../services/authService';

const RoleBasedRoute = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // Check user role when component mounts
        checkUserRole();
    }, []);

    const checkUserRole = () => {
        // First check if user is authenticated
        if (!isAuthenticated()) {
            navigate('/login');
            return;
        }

        // Get user data from localStorage
        try {
            const userStr = localStorage.getItem("user");
            if (userStr) {
                const userData = JSON.parse(userStr);

                // Route based on user role
                switch (userData.role) {
                    case "Stock Keeper":
                        navigate("/stock-dashboard");
                        break;
                    case "Supervisor":
                        navigate("/supervisor-dashboard");
                        break;
                    case "Cashier":
                        navigate("/cashier-dashboard");
                        break;
                    default:
                        // Admin, Manager or other roles go to regular dashboard
                        navigate("/dashboard");
                        break;
                }
            } else {
                // No user data found, redirect to dashboard
                console.warn("No user data found in localStorage");
                navigate("/dashboard");
            }
        } catch (error) {
            console.error("Error parsing user data:", error);
            // If there's an error, default to regular dashboard
            navigate("/dashboard");
        }
    };

    // Render the child routes (this will be replaced by the redirects in useEffect)
    return <Outlet />;
};

export default RoleBasedRoute;